import React from 'react';

export function Logo({ size = 'md', showText = true, className = '' }) {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20',
    '2xl': 'w-28 h-28',
    '3xl': 'w-36 h-36',
    '4xl': 'w-48 h-48'
  };

  const textSizes = {
    sm: 'text-base',
    md: 'text-lg',
    lg: 'text-xl',
    xl: 'text-2xl',
    '2xl': 'text-3xl',
    '3xl': 'text-4xl',
    '4xl': 'text-5xl'
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img 
        src="/images/ai-horse-logo.png" 
        alt="AI Horse-Powered" 
        className={`${sizes[size]} object-contain`}
      />
      {showText && (
        <span className={`font-heading font-bold ${textSizes[size]} text-white hidden lg:block`}>
          AI Horse-Powered
        </span>
      )}
    </div>
  );
}

export function LogoIcon({ size = 'md', className = '' }) {
  const sizes = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
    '2xl': 'w-24 h-24',
    '3xl': 'w-32 h-32',
    '4xl': 'w-48 h-48',
    hero: 'w-64 h-64'
  };

  return (
    <img 
      src="/images/ai-horse-logo.png" 
      alt="AI Horse-Powered" 
      className={`${sizes[size]} object-contain ${className}`}
    />
  );
}
